import {StyleSheet, Text, View} from '@react-pdf/renderer';
import React from 'react';
import {Style} from '@react-pdf/types';

export const styles = StyleSheet.create({
	textHeader: {
		color: '#000000',
		fontSize: '18px',
		fontFamily: 'Helvetica-Bold',
	},
	fromToText: {
		color: '#6B6D7B',
		fontSize: '12px',
		fontFamily: 'Helvetica',
		paddingRight: '11px',
	},
	textMain: {
		color: '#000000',
		fontSize: '10px',
		fontFamily: 'Helvetica',
	},
	textMain12: {
		color: '#000000',
		fontSize: '12px',
		fontFamily: 'Helvetica',
		paddingBottom: '8px',
	},
	textTableRight: {
		color: '#000000',
		fontSize: '10px',
		fontFamily: 'Helvetica',
		textAlign: 'right',
	},
	textSummary: {
		color: '#000000',
		fontSize: '10px',
		fontFamily: 'Helvetica',
		paddingTop: '12px',
	},
	textSummaryBold: {
		color: '#000000',
		fontSize: '12px',
		fontFamily: 'Helvetica-Bold',
		paddingTop: '12px',
	},
	textMainBold: {
		color: '#000000',
		fontSize: '12px',
		fontFamily: 'Helvetica-Bold',
	},
	textMainBold10: {
		color: '#000000',
		fontSize: '12px',
		fontFamily: 'Helvetica-Bold',
	},
	viewRow: {
		flexDirection: 'row',
	},
	viewLine: {
		flexDirection: 'row',
		paddingLeft: '10px',
		paddingRight: '20px',
		minHeight: '30px',
		alignItems: 'center',
		borderBottom: '1px solid #d3d3df',
		borderLeft: '1px solid #d3d3df',
		borderRight: '1px solid #d3d3df',
	},
});

type LayoutComponent = React.PropsWithChildren<{
	style?: Style;
}>;

interface ViewRowProps extends LayoutComponent {
	fixed?: boolean;
}

export const ViewRow = ({style = {}, children, fixed = false}: ViewRowProps): JSX.Element => {
	return (
		<View fixed={fixed} style={[styles.viewRow, style]}>
			{children}
		</View>
	);
};

export const ViewLine = ({style = {}, children}: LayoutComponent): JSX.Element => {
	const lineStyle = styles.viewLine;
	return <View style={[lineStyle, style]}>{children}</View>;
};

export const TextHeader = ({style = {}, children}: LayoutComponent): JSX.Element => {
	return <Text style={[styles.textHeader, style]}>{children}</Text>;
};
